module.exports = __webpack_public_path__ + "assets/img/6_460_big.4947bf96.jpg";